var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pa-0 ma-0 d-flex align-center justify-center",
      style: { background: _vm.bgColor },
    },
    [_c("svg", { attrs: { id: _vm.rootElementId } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }